//// Generated by Torna Api Visitor 2.5.6 DO NOT EDIT IT DIRECTLY!
//// @name         用户中心/用户中心app/短信登录
//// @apiUrl       /auth/login/sms
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiHttp } from '@/network/ApiHttp';
import { checkReply } from './checkReply';
export var AuthLoginSms_post;
(function (AuthLoginSms_post) {
    function call(body, canceller) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = __SERVER__ + "/auth/login/sms";
            const reply = yield apiHttp["POST"](Object.assign({ url, params: undefined, headers: undefined, data: body }, canceller === null || canceller === void 0 ? void 0 : canceller.signals()));
            return checkReply(reply);
        });
    }
    AuthLoginSms_post.call = call;
})(AuthLoginSms_post || (AuthLoginSms_post = {}));
export default AuthLoginSms_post;
